module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.volonters.red-09484eace8bc1ac70223499eefed72e7.svg";